import {
    HashLocationStrategy,
    LocationStrategy,
    PathLocationStrategy,
} from '@angular/common';
import { LocationStrategyEnum } from '../../enums/location-strategy/location-strategy.enum';

export const provideLocationStrategy = (
    locationStrategy: LocationStrategyEnum,
) => ({
    provide: LocationStrategy,
    useClass:
        locationStrategy === LocationStrategyEnum.HASH
            ? HashLocationStrategy
            : PathLocationStrategy,
});
